/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataDocument = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h20v20H2zm2 2v16h16V4zm2 3h5v2H6zm7 0h5v2h-5zm0 4h5v2h-5zm0 4h5v2h-5z" />
        <path d="M11 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgDataDocument as DataDocument };
